/**
 * Arraste do quadro de compras (ADR-0069): NENHUM arraste é bloqueado na
 * tela. O backend (`POST /requisicoes/{id}/mover-para`) resolve a transição
 * para qualquer destino e responde 409 `{precisa}` quando falta algo que só
 * um modal pode pedir. Esta tabela só antecipa o que já sabemos que vai
 * precisar de motivo/observação, para abrir o modal ANTES da primeira
 * chamada e poupar uma ida ao servidor.
 */

const TERMINAIS = new Set(["ATENDIDA", "CANCELADA"]);
const ORDEM = ["RASCUNHO", "EM_COTACAO", "APROVADA", "AGUARDANDO_ENTREGA", "ATENDIDA"];

/** Situação-alvo de uma coluna do quadro (null = coluna operacional). */
export function destinoDaColuna(situacoesColuna) {
  if (!situacoesColuna || situacoesColuna.length === 0) return null;
  return situacoesColuna[0];
}

/**
 * O que a tela precisa pedir antes de mover `atual` para `destino`:
 * - `null`: nada muda (mesma situação, ou coluna operacional);
 * - `"motivo"`: cancelar ou voltar etapa;
 * - `"observacao"`: dar por recebida (fechamento manual / confirmar recebimento);
 * - `""`: pode chamar direto.
 */
export function precisaAntesDeMover(atual, destino) {
  if (!destino || atual === destino) return null;
  if (destino === "CANCELADA") return "motivo";
  const voltando = TERMINAIS.has(atual) || ORDEM.indexOf(destino) < ORDEM.indexOf(atual);
  if (voltando) return "motivo";
  if (destino === "ATENDIDA") return "observacao";
  return "";
}

/** Compat com quem ainda importa o nome antigo (o Kanban compartilhado não usa). */
export function transicaoParaColuna(atual, situacoesColuna) {
  const destino = destinoDaColuna(situacoesColuna);
  if (!destino || situacoesColuna.includes(atual)) return null;
  return { destino, precisa: precisaAntesDeMover(atual, destino) };
}
